import type { ReactElement } from 'react'
import { cn } from '@/lib/cn'

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizes: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'size-3.5',
  md: 'size-5',
  lg: 'size-8'
}

/**
 * Drawn as an SVG rather than a bordered box so the track and the arc can both
 * ride on `currentColor` — one spinner works on every surface and fill.
 */
export function Spinner({ size = 'md', className }: SpinnerProps): ReactElement {
  return (
    <svg
      className={cn('shrink-0 animate-spin', sizes[size], className)}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12" cy="12" r="9.5" stroke="currentColor" strokeWidth="2.5" opacity="0.2" />
      <path
        d="M21.5 12A9.5 9.5 0 0 0 12 2.5"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
